import _ from 'lodash';

import ActionTypes from 'app/error/ActionTypes';
import { FAILURE } from 'app/entity/utils/statuses';

const reducer = (state = [], action) => {
  if (action.type === ActionTypes.CLEAR_ERROR) {
    return _.without(state, action.error);
  }

  if (
    action.error &&
    action.error.shouldGlobalizeError !== false &&
    action.shouldGlobalizeError !== false
  ) {
    return state.concat(action.error);
  }

  if (
    action.shouldGlobalizeError &&
    action.status === FAILURE &&
    !_.isEmpty(action.messages)
  ) {
    const { messages } = action;
    const isError = _.isError(messages);
    const error = isError ? messages : new Error(messages);
    return state.concat(error);
  }

  if (action.type === ActionTypes.CLEAR_ERRORS) {
    return [];
  }

  return state;
};

export default reducer;
